import {
  BaseApplicantSchema as ApplicantSchema,
  createEditSinAndLoanAmountSchema,
  OriginationTracking,
} from '@applyonline/shared'
import * as yup from '@if/core/yup'
import { FinancingConfigDto } from './../../node_modules/@applyonline/shared/types/FinancingConfigApi'

export const buildPrequalificationSchema = (financingProgramConfig: FinancingConfigDto) => {
  return yup.object({
    applicant: ApplicantSchema().required(),
    requestedLoanAmount: yup
      .double()
      .nullable()
      .default(null)
      .required()
      .min(financingProgramConfig.minimumLoanAmount)
      .max(financingProgramConfig.maximumLoanAmount),
    merchantId: yup.string().nullable().default(null),
  })
}

export type Prequalification = yup.InferSubmit<ReturnType<typeof buildPrequalificationSchema>> & {
  lastTouchOrigination: OriginationTracking | null
  firstTouchOrigination: OriginationTracking | null
}

export const buildLoanAmountInputSchema = (financingProgramConfig: FinancingConfigDto) => {
  return buildPrequalificationSchema(financingProgramConfig).pick(['requestedLoanAmount'])
}

export type LoanAmountInput = yup.InferSubmit<ReturnType<typeof buildLoanAmountInputSchema>>

export const PersonalInformationInputSchema = ApplicantSchema()
  .pick([
    'firstName',
    'middleName',
    'lastName',
    'languageId',
    'hasLegalName',
    'legalName',
    'cellPhone',
    'homePhone',
    'email',
    'subscribeNewsletter',
  ])
  .shape({
    cellPhone: yup.string().validCanadianPhone().required(),
  })

export type PersonalInformationInput = yup.InferSubmit<typeof PersonalInformationInputSchema>

export const PersonalDetailsSchema = ApplicantSchema().pick([
  'genderId',
  'birthDate',
  'sin',
  'currentAddress',
  'spending',
])

export type PersonalDetails = yup.InferSubmit<typeof PersonalDetailsSchema>

export const buildEditSinAndLoanAmountSchema = (minLoanAmount: number, maxLoanAmount: number) =>
  createEditSinAndLoanAmountSchema(minLoanAmount, maxLoanAmount)

export type EditSinAndLoanAmount = yup.InferSubmit<ReturnType<typeof buildEditSinAndLoanAmountSchema>>
